import React from 'react';

const DividerInput: React.FC = () => (
  <div className="w-full mx-3 my-3">
    <div className="border-b border-slate-200 " />
  </div>
);

export default DividerInput;
